import { cn } from "@faire/react/tools/cn";
import React from "react";

type IProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalBodyBase: React.FC<IProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={cn("fs-modal__body", className)} {...props}>
      {children}
    </div>
  );
};
